module.exports = "/assets/data/f9dde301af00ea3d7133af9528c535ae-KT8.data.json";